import type { ISettingValue } from "@bbj-types/setting";
import { coachingStageLabel } from "./constants";

export const coachingStageGetLabel = <T extends Pick<ISettingValue, "metadata">>(opt: T) => {
  if (opt.metadata?.coachingStage) {
    const v = coachingStageLabel[opt.metadata.coachingStage];
    if (typeof v === "string") {
      return v;
    }
  }
  return "";
};

export const coachingStepsSortByStage = <T extends Pick<ISettingValue, "metadata" | "label">>(a: T, b: T) => {
  if (a.metadata?.coachingStage !== b.metadata?.coachingStage) {
    if (a.metadata?.coachingStage === "beforeCoaching") {
      return -1;
    }
    if (b.metadata?.coachingStage === "beforeCoaching") {
      return 1;
    }
    if (a.metadata?.coachingStage === "coached") {
      return 1;
    }
    if (b.metadata?.coachingStage === "coached") {
      return -1;
    }
  }
  return 0;
};

export const coachingStepsSortByStageInterviewExit = <T extends Pick<ISettingValue, "metadata" | "label">>(
  a: T,
  b: T
) => {
  if (a.metadata?.coachingStage !== b.metadata?.coachingStage) {
    if (a.metadata?.coachingStage === "coached") {
      return -1;
    }
    if (b.metadata?.coachingStage === "coached") {
      return 1;
    }
    if (a.metadata?.coachingStage === "beforeCoaching") {
      return 1;
    }
    if (b.metadata?.coachingStage === "beforeCoaching") {
      return -1;
    }
  }
  return a.label.localeCompare(b.label);
};
